import { render, staticRenderFns } from "./SalesChannelPromotionForm.vue?vue&type=template&id=af64a3a6"
import script from "./SalesChannelPromotionForm.vue?vue&type=script&lang=js"
export * from "./SalesChannelPromotionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports